import React from 'react'

// components
import {ButtonCancel, CustomButton} from "../buttons/buttonsActions";

// labels
import {HAS_RECURRING_SCHEDULE, NO, YES_CONFIRM} from "../i18n/i18n";

const SelectScheduleType = props => {
    const { setRecurrentHours } = props

    const onSelectOption = value => setRecurrentHours(value)

    return <>
        <h3>{HAS_RECURRING_SCHEDULE}</h3>
        <br />

       <ButtonCancel size={'sm'} title={ NO } onClick={() => onSelectOption(false)}/>
        &nbsp;
       <CustomButton title={ YES_CONFIRM } onClick={() => onSelectOption( true)}/>
    </>
}

export default SelectScheduleType